export default "__VITE_ASSET__DBImDKY___"